import { SaveOutlined } from '@ant-design/icons';
import { useValidateInspectorForm } from '@smx-ui-inspector/hook/use-validate';
import { setterInspector } from '@smx-ui-inspector/store/slices/inspector-slice';
import { Button, FormInstance } from 'antd';
import axios from 'axios';
import { FC, memo } from 'react';
import { useDispatch } from 'react-redux';
import { useMutation } from 'react-relay';
import { GraphQLTaggedNode, MutationParameters, PayloadError } from 'relay-runtime';

import { DrawingSetCreateInput } from '../graphql/__generated__/createDrawingSetMutation.graphql';
import { AppDispatch } from '../store';
import { setIsUpdateAfterUploadDrawingSetVersion } from '../store/drawings-slice';

interface FormButtonSaveSetDrawingsProps {
    values?: any;
    form?: FormInstance;
    connectionId?: string;
    mutation: GraphQLTaggedNode;
    responseSource: string;
}

const FormButtonSaveSetDrawings: FC<FormButtonSaveSetDrawingsProps> = ({
    values,
    form,
    responseSource,
    connectionId,
    mutation,
}) => {
    const dispatch = useDispatch<AppDispatch>();
    const { validate } = useValidateInspectorForm(form);

    const [commitCreate, isInFlightCreating] = useMutation(mutation);

    const uploadToUrl = (url: string, presignedForm: any, file: File, onProgress?: (percent: number) => void) => {
        const formData = new FormData();

        Object.entries(presignedForm).forEach(([key, value]) => {
            formData.append(key, value as string);
        });

        formData.append('file', file);

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
            onUploadProgress: (progressEvent) => {
                const percent = Math.round((progressEvent.loaded * 100) / (progressEvent.total || 1));
                if (onProgress) onProgress(percent);
            },
        });
    };

    const commit = (input: DrawingSetCreateInput): MutationParameters => {
        return {
            variables: {
                input: input,
                connections: connectionId ? [connectionId] : [],
            },
            onCompleted: (response: any, errors: PayloadError[]) => {
                if (errors) {
                    console.log(
                        (
                            errors[0] as PayloadError & {
                                extensions: { debugMessage: string };
                            }
                        ).extensions.debugMessage,
                        errors,
                    );
                } else {
                    console.log('Save drawings set successful', response, values, values.file.fileList[0]);
                    const uploadData = JSON.parse(response[responseSource].uploadFields);

                    uploadToUrl(
                        response[responseSource].uploadUrl,
                        uploadData,
                        values.file.fileList[0].originFileObj as File,
                        (percent) => {
                            console.log('>>>', percent);
                        },
                    );

                    dispatch(setIsUpdateAfterUploadDrawingSetVersion({ [values.drawingSetId]: true }));
                    dispatch(setterInspector({ nameNewEntity: undefined }));
                    console.log(uploadData);
                }
            },
            onError: (error: any) => {
                console.error('Mutation error:', error);
            },
        } as unknown as MutationParameters;
    };

    const onClick = async () => {
        if (await validate()) {
            const data = {
                tags: values.tags?.join(','),
                versionDate: values.versionDate.unix(),
                fileName: values.fileName,
                name: values.name,
                measureUnit: values.measureUnit,
                projectId: values.projectId,
                drawingSetId: values.drawingSetId,
            };

            commitCreate(commit(data));
            console.log(data, mutation);
        }
    };

    return (
        <Button icon={<SaveOutlined />} onClick={onClick} loading={isInFlightCreating}>
            Save
        </Button>
    );
};

export default memo(FormButtonSaveSetDrawings);
